import { Facebook, Twitter, Linkedin, Instagram, Youtube, LucideIcon } from "lucide-react";
import { cn } from "@/lib/utils";

interface SocialLink {
  name: string;
  href: string;
  icon: LucideIcon;
}

const defaultSocialLinks: SocialLink[] = [
  { name: "Facebook", href: "#", icon: Facebook },
  { name: "Twitter", href: "#", icon: Twitter },
  { name: "LinkedIn", href: "#", icon: Linkedin },
  { name: "Instagram", href: "#", icon: Instagram },
  { name: "YouTube", href: "#", icon: Youtube },
];

interface SocialLinksProps {
  links?: SocialLink[];
  className?: string;
  iconClassName?: string;
}

export const SocialLinks = ({
  links = defaultSocialLinks,
  className,
  iconClassName,
}: SocialLinksProps) => {
  return (
    <div className={cn("flex items-center gap-4", className)}>
      {links.map((link) => (
        <a
          key={link.name}
          href={link.href}
          className="text-card/70 hover:text-card transition-colors"
          aria-label={link.name}
        >
          <link.icon className={cn("h-5 w-5", iconClassName)} />
        </a>
      ))}
    </div>
  );
};
